export default "__VITE_ASSET__ac91ae9a__"